import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export default function useDefinitions() {
  const { pathname } = useLocation()
  const { allocationID } = useParams()

  return useMemo(() => ({
    entityName: 'Subid',
    entityNamePlural: 'Subids',
    entityNameModule: 'offer',
    basePath: pathname,
    defaultParams: {
      allocation_id: allocationID,
    },
    menuToggle: false,
  }), [pathname, allocationID])
}
